// 判定系

// null または undefined
export function isBlank(value) {
    if (value === null || value === '' || typeof value === 'undefined') {
        return true;
    }

    return false;
}
